import { Model } from '@/model/Model'

export class Transaction extends Model {
  constructor (args) {
    super(args)
    this.original_value = this.value_parcel
  }
}
